/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataCustomFieldsQueryResponse, AuditReportsGetGipMetadataCustomFields401, AuditReportsGetGipMetadataCustomFields403 } from "../models/AuditReportsGetGipMetadataCustomFields";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetGipMetadataCustomFields } from "../axios/auditReportsGetGipMetadataCustomFields";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetGipMetadataCustomFieldsQueryKey = () => ["api-v2", { url: '/audit-reports/v1/reports/gip/metadata/custom-fields' }] as const

export type AuditReportsGetGipMetadataCustomFieldsQueryKey = ReturnType<typeof auditReportsGetGipMetadataCustomFieldsQueryKey>

export function auditReportsGetGipMetadataCustomFieldsQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetGipMetadataCustomFieldsQueryKey()
        return queryOptions<AuditReportsGetGipMetadataCustomFieldsQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataCustomFields401 | AuditReportsGetGipMetadataCustomFields403>, AuditReportsGetGipMetadataCustomFieldsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetGipMetadataCustomFields({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Return GIP custom field keys for the client
 * {@link /audit-reports/v1/reports/gip/metadata/custom-fields}
 */
export function useAuditReportsGetGipMetadataCustomFields<TData = AuditReportsGetGipMetadataCustomFieldsQueryResponse, TQueryData = AuditReportsGetGipMetadataCustomFieldsQueryResponse, TQueryKey extends QueryKey = AuditReportsGetGipMetadataCustomFieldsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetGipMetadataCustomFieldsQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataCustomFields401 | AuditReportsGetGipMetadataCustomFields403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetGipMetadataCustomFieldsQueryKey()
         

         const query = useQuery({
          ...auditReportsGetGipMetadataCustomFieldsQueryOptions(config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetGipMetadataCustomFields401 | AuditReportsGetGipMetadataCustomFields403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}